import {config} from "@/constants/config";
import type {Wallet, WalletAccount, WalletAccountApi, WalletApiResponse} from "./wallet.types";

const adaptAccount = (account: WalletAccountApi): WalletAccount => ({
  currency: account.currency,
  balance: account.balance,
  formattedBalance: account.formattedBalance ?? `${account.balance}`,
  lockedBalance: account.locked_balance ?? 0,
  formattedLockedBalance: account.formatted_locked_balance ?? "0,00",
});

export const adaptWallet = (response: WalletApiResponse): Wallet => {
  const accounts = response.data.data.accounts.map(adaptAccount);
  const defaultAccount = accounts.find(account => account.currency === config.defaultCurrency) ?? accounts[0] ?? null;
  return {accounts, defaultAccount};
};
